<template>
  <div class="about">
    <div class="container lg" :class="s.wrap">
      <div v-if="!flag.showRegistForm" >
        <spacer :y="20" />
        <p class="text-center">MITTは地方都市タクシー配車アプリです！</p>
        <spacer :y="2" />
        <div class="d-flex justify-content-center">
          <basic-btn @click="flag.showRegistForm = true">登録情報入力へ進む</basic-btn>
        </div>
      </div>
      <div v-else>
        <spacer :y="2" />
        <h3 class="text-center">ライドシェアドライバー登録</h3>
        <spacer :y="2" />
        <Form
          v-model:items="registBaseData"
          @changeSubmitFlag="changeFormSubmitFlag" />
        <spacer :y="2" />
        <div class="d-flex justify-content-center">
          <basic-btn
            width="full"
            @click="submitRegist" :disabled="!flag.readyRegist">登録する</basic-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  BasicBtn,
  Spacer,
  Form,
} from '@/components/parts';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'about',
  components: {
    BasicBtn,
    Spacer,
    Form,
  },
  mixins: [cf],
  data() {
    return {
      flag: {
        showRegistForm: false,
        readyRegist: false,
      },
      registBaseData: [
        {
          name: 'username',
          label: '氏名',
          type: 'text',
          required: true,
          value: '',
        },
        {
          name: 'birthday',
          label: '生年月日',
          type: 'date',
          showAge: true,
          required: true,
          value: '',
        },
        {
          name: 'email',
          label: 'メールアドレス',
          type: 'email',
          required: true,
          confirm: true, // 確認用メールアドレス欄表示・一致確認フラグ
          value: '',
        },
        {
          name: 'tel',
          label: '電話番号',
          type: 'text',
          required: true,
          value: '',
        },
        {
          name: 'address',
          label: '住所',
          type: 'text',
          required: true,
          value: '',
        },
        {
          name: 'car_type',
          label: '主に使用する車種',
          type: 'select',
          required: true,
          options: [
            { label: '普通車', value: 'standard' },
            { label: '軽自動車', value: 'compact' },
            { label: 'その他', value: 'other' },
            { label: '車無し(タクシー事業者の車)', value: 'none' },
          ],
          value: 0,
        },
        {
          name: 'license_image_front',
          label: '免許証画像(表面)',
          type: 'image',
          accept: 'image/png, image/jpeg',
          required: true,
          value: null,
        },
        {
          name: 'license_image_back',
          label: '免許証画像(裏面)',
          type: 'image',
          accept: 'image/png, image/jpeg',
          required: true,
          value: null,
        },
      ],
    };
  },
  created() {},
  computed: {
    ...mapState(['helper']),
  },
  methods: {
    changeFormSubmitFlag(flag) {
      this.flag.readyRegist = flag;
    },

    /** 段階制ローディング表示 */
    showLoading() {
      const steps = {
        allSteps: 4,
        now: 0,
      };
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple', data: steps };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    nextModalLoadingStep() {
      const steps = this.$store.state.modal.loadings.data;
      steps.now += 1;
      this.$store.dispatch('modal/loadings/updateData', steps, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },


    async submitRegist() {
      if (!this.flag.readyRegist) return;
      this.showLoading();
      try {
        const userObj = cf.pullOutValues(this.registBaseData);
        /** user基本情報登録 */
        const userId = await this.createUser(userObj);
        if (!userId) throw new Error('failed to create user.');
        this.nextModalLoadingStep();

        /** 免許画像アップロード */
        const licenseImages = [
          {
            name: 'license_front_path',
            image: userObj.license_image_front,
          },
          {
            name: 'license_back_path',
            image: userObj.license_image_back,
          },
        ];
        const uploadedImages = [];
        await Promise.all(
          licenseImages.map(async ({ name, image }) => {
            const s3Path = await this.uploadLicenseImage(userId, image);
            uploadedImages.push({ name, value: s3Path });
            this.nextModalLoadingStep();
          }),
        );
        // valueが全てあるか確認
        const isAllUploaded = uploadedImages.every((image) => image.value);
        if (!isAllUploaded) throw new Error('failed to upload license images.');

        /** appDriverAdditionalsに免許のパスを登録 */
        await this.createAppDriverAdditionals(userId, uploadedImages);
        this.nextModalLoadingStep();
      } catch (error) {
        alert('登録処理中にエラーが発生しました。再度お試しください。');
        console.log(error);
      } finally {
        this.hideLoading();
      }
    },

    async createUser(userObj) {
      // user基本情報登録
      const data = {
        username: userObj.username,
        flag: 20, // オペレータ承認待ち
        role: 13, // アプリドライバー
        route: 'appDriver',
        tel: userObj.tel,
        officeId: 1, // とりあえず沼田屋
        email: userObj.email,
        additionals: {
          address: userObj.address,
          car_type: userObj.car_type,
          birthday: userObj.birthday,
        },
      };
      let userId = null;
      let activatekey = null;
      await this.axios({
        method: 'post',
        url: '/v1/user/create',
        data,
      })
        .then((response) => {
          const res = response.data;
          userId = res?.userID || null;
          activatekey = res?.activatekey || null;
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });

      if (userId && activatekey) {
        cf.saveLocalStorage({ activatekey, step: 'registed-user-info' }, 'mitt');
      }
      return userId;
    },

    async uploadLicenseImage(userId, image) {
      const formData = new FormData();
      formData.append('file', image);

      let s3Path = null;
      await this.axios({
        method: 'post',
        url: '/v1/image/upload',
        data: formData,
        params: {
          environment: this.helper.env.name,
          flag: 1,
          user_id: userId,
          isOnlyUpload: 1,
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((response) => {
          const res = response.data;
          s3Path = res?.resultData?.uploaded?.s3Path || null;
        })
        .catch((err) => {
          console.log(err);
          throw err;
        });
      return s3Path;
    },

    async createAppDriverAdditionals(userId, images) {
      const data = {
        user_id: userId,
        items: images,
      };

      await this.axios({
        method: 'post',
        url: '/v1/appDriverAdditionals/update',
        data,
      })
        .then(() => {})
        .catch((err) => {
          console.log(err);
          throw err;
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  margin-top: var(--header-height);
}
</style>
